// The names of the two sign-in cookies: the password step's, then the
// two-factor step's.
//
// Each school gets its own names, e.g. sie_sa_auth_krcs on krcs.simulalert.com.
// With one shared name, a school whose cookies are scoped to simulalert.com
// (DCS) has them visible on every other school's dashboard as well. A browser
// signed in to DCS then looks signed in here, the server rejects the cookie,
// and the dashboard signs the user out again and again.
//
// The server works the names out the same way from its DASHBOARD_URL
// (util/sessionCookies.js there), so the two must be kept in step.

/**
 * The suffix for a dashboard hostname: its first label, so krcs.simulalert.com
 * gives "krcs". Blank for localhost, an IP address or a bare name, which keeps
 * the plain names in local development.
 */
export function suffixForHostname(hostname) {
  const host = (hostname || '').trim().toLowerCase().replace(/^www\./, '');

  if (host === '' || !host.includes('.') || /^[\d.]+$/.test(host) || host.includes(':')) {
    return '';
  }

  return host.split('.')[0].replace(/[^a-z0-9-]/g, '');
}

function named(base) {
  const suffix = suffixForHostname(window.location.hostname);
  return suffix === '' ? base : `${base}_${suffix}`;
}

/** The password step's cookie. */
export const AUTH_COOKIE = named('sie_sa_auth');

/** The two-factor step's cookie, which marks a completed sign-in. */
export const TWO_FACTOR_COOKIE = named('sie_sa_2fa');
